import React, { useState } from 'react'
import { Button, Dropdown, Form, Input, Menu } from "antd"
import { DownOutlined } from "@ant-design/icons"
import moment from "moment"

import { useStore } from "../contexts/FireStoreContext"

const FilterByDate = ({ table, column = '', setResult, stickyCondition = [] }) => {
  const options = [
    { value: "all", label: "All" },
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "week", label: "This Week" },
    { value: "month", label: "This Month" }
  ]

  const [selected, setSelected] = useState("All")

  const { getDocuments } = useStore()

  const handleDateChange = (key) => {
    setSelected(options.find(o => o.value === key).label)
    let start = 0
    let end = 0
    switch (key) {
      case "today":
        start = moment().utc().endOf('day').valueOf()
        end = moment().utc().startOf("day").valueOf()
        break
      case "yesterday":
        start = moment().utc().startOf('day').valueOf()
        end = moment().subtract(1, "days").utc().startOf("day").valueOf()
        break
      case "week":
        start = moment().utc().endOf('day').valueOf()
        end = moment().utc().startOf("week").valueOf()
        break
      case "month":
        start = moment().utc().endOf('day').valueOf()
        end = moment().startOf("month").valueOf()
        break
      case "year":
        start = moment().utc().endOf('day').valueOf()
        end = moment().startOf("year").valueOf()
        break
      default:
        start = 0
        end = 0
        break
    }
    if (start > 0 && end > 0) {
      getDocuments(table, [], [column, start, end])
        .then(items => {
          console.log(items)
          if (stickyCondition.length > 0) {
            const tmp = items.filter(item => item[stickyCondition[0]] === stickyCondition[2])
            setResult(tmp, (tmp.length + 1))
          } else {
            setResult(items, (items.length + 1))
          }
        }).catch(err => {
          console.log(err)
        })
    } else {
      setResult([], 0)
    }
  }

  const menu = (
    <Menu>
      {options.map(option => (
        <Menu.Item key={option.value}>
          <Button type="text" onClick={() => handleDateChange(option.value)}>{option.label}</Button>
        </Menu.Item>
      ))}
    </Menu>
  )

  return (
    <Input.Group>
      {/* <Form.Item noStyle>
        <Input style={{ width: '40%' }} placeholder="Filter By" className="border-primary" readOnly />
      </Form.Item> */}
      <Form.Item noStyle>
        <Dropdown overlay={menu} trigger={['click']}>
          <Button type="primary" className="border-primary">
            {selected} <DownOutlined />
          </Button>
        </Dropdown>
      </Form.Item>
    </Input.Group>
  )
}

export default FilterByDate
